import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';
import { UserLogin } from 'src/app/models/UserLogin';
import { GlobalMethodsService } from '../global-methods.service';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { GlobalVariablesService } from '../global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router,
    private navCtrl: NavController,
    private gms: GlobalMethodsService,
    private gvs: GlobalVariablesService) { }

  public async goTo(url, replaceUrl: boolean = false) {
    if (replaceUrl) {
      await this.router.navigate([url], { replaceUrl: true });
    } else {
      await this.navCtrl.navigateForward(url, { animated: false });
    }
  }

  public goBack() {
    this.navCtrl.back({ animated: false });
  }

  goHome() {
    this.navCtrl.navigateRoot('/home', { animated: false });
  }

  async logout(clearSession: boolean = true, userLogin?: UserLogin) {
    if(clearSession){
      await this.gms.clearSession(userLogin);
      FirebaseAnalytics.reset();
    }
    this.gms.setStatusTimerPanel(false);
    this.gms.setStatusNewsPanel(false);
    this.gms.setStatusAlarm(false);
    this.gms.setSetupPage(false, false, false, false);
    this.gms.setLoadingFalse();
    this.gvs.craChatID = 0;
    this.gvs.supportChatID = 0;
    this.navCtrl.navigateRoot('/login', { animated: false });
  }
  
  closeApp() {
    navigator['app'].exitApp();
  }
}
